<template>
  <div class="video-wall">
    <div class="video-wall__toolbar">
      <div class="video-wall__title">
        <i class="el-icon-video-camera"></i>
        <span>实时视频</span>
        <el-tag size="mini" type="success" effect="dark">海康 NVR · ZLMediaKit</el-tag>
      </div>
      <div class="video-wall__actions">
        <span class="video-wall__label">桥梁</span>
        <el-select v-model="selectedBridgeId" size="mini" style="width:220px" @change="onBridgeChange" filterable>
          <el-option v-for="b in bridges" :key="b.bridgeId"
                     :label="b.bridgeName + '（' + b.pullable + '/' + b.channels + ' 路可播）'"
                     :value="b.bridgeId" />
        </el-select>
        <el-tag v-if="selectedBridgeId && currentBridgePullable === 0" type="warning" size="mini" effect="dark">
          该桥梁 NVR 未开放 RTSP
        </el-tag>
        <el-button size="mini" type="primary" icon="el-icon-s-operation"
                   :disabled="!activeChannel || !activeChannel.pullable" @click="ptzVisible = true">
          云台控制
        </el-button>
      </div>
    </div>

    <div class="video-wall__main">
      <bridge-video-panel
        :bridge-id="selectedBridgeId"
        default-layout="2x2"
        :show-channel-list="true"
        :show-channel-select="false"
        :show-layout-switch="true"
        :show-refresh="true"
        :side-title="currentBridgeName || '未选择桥梁'"
        @active-change="onActiveChange"
      ></bridge-video-panel>
    </div>

    <el-drawer title="云台控制" :visible.sync="ptzVisible" direction="rtl" size="340px"
               :modal="false" custom-class="ptz-drawer">
      <div class="ptz-drawer__inner" v-if="activeChannel">
        <ptz-control-panel
          :nvr-id="activeChannel.nvrId"
          :channel="activeChannel.channel"
          :nvr-label="'NVR#' + activeChannel.nvrId + ' · ' + (activeChannel.name || ('CH' + activeChannel.channel))"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import BridgeVideoPanel from '@/components/video/BridgeVideoPanel.vue'
import PtzControlPanel from '@/components/video/PtzControlPanel.vue'
import { getBridges } from '@/api/video'
import BridgeEventBus from '@/utils/BridgeEventBus'

export default {
  name: 'VideoWall',
  components: { BridgeVideoPanel, PtzControlPanel },
  data() {
    return {
      bridges: [],
      selectedBridgeId: null,
      activeChannel: null,
      ptzVisible: false
    }
  },
  computed: {
    currentBridgeName() {
      const b = this.bridges.find(x => x.bridgeId === this.selectedBridgeId)
      return b ? b.bridgeName : ''
    },
    currentBridgePullable() {
      const b = this.bridges.find(x => x.bridgeId === this.selectedBridgeId)
      return b ? b.pullable : 0
    }
  },
  created() {
    this.loadBridges()
    BridgeEventBus.$on('bridge-changed', this.onBridgeChanged)
  },
  beforeDestroy() {
    BridgeEventBus.$off('bridge-changed', this.onBridgeChanged)
  },
  methods: {
    async loadBridges() {
      try {
        const res = await getBridges()
        this.bridges = ((res && res.data) || []).slice().sort((a, b) => (b.pullable - a.pullable))
      } catch (e) {
        this.bridges = []
      }
      const chosen = this.resolveCurrentBridgeId()
      const firstPullable = this.bridges.find(b => b.pullable > 0)
      this.selectedBridgeId = chosen || (firstPullable ? firstPullable.bridgeId : (this.bridges[0] ? this.bridges[0].bridgeId : null))
    },
    resolveCurrentBridgeId() {
      try {
        const raw = localStorage.getItem('selectedBridge')
        if (raw) {
          const b = JSON.parse(raw)
          const id = b.id || b.bridgeId
          if (id && this.bridges.some(x => String(x.bridgeId) === String(id))) return Number(id)
        }
      } catch (e) { /* ignore */ }
      return null
    },
    onBridgeChanged() {
      const id = this.resolveCurrentBridgeId()
      if (id && String(id) !== String(this.selectedBridgeId)) {
        this.selectedBridgeId = id
      }
    },
    onBridgeChange() {
      // bridgeId 变化后，BridgeVideoPanel 会自动重载通道与拉流
    },
    onActiveChange(ch) {
      this.activeChannel = ch
    }
  }
}
</script>

<style scoped>
.video-wall { height: 100%; display: flex; flex-direction: column; background: #0f172a; }
.video-wall__toolbar {
  height: 48px; flex: 0 0 48px; display: flex; align-items: center; justify-content: space-between;
  padding: 0 16px; background: #1e293b; color: #e2e8f0; border-bottom: 1px solid #334155;
}
.video-wall__title { display: flex; align-items: center; gap: 8px; font-size: 15px; font-weight: 600; }
.video-wall__title i { font-size: 18px; color: #38bdf8; }
.video-wall__actions { display: flex; align-items: center; gap: 10px; }
.video-wall__label { font-size: 12px; color: #94a3b8; }
.video-wall__main { flex: 1; min-height: 0; }
.ptz-drawer__inner { padding: 16px; }
</style>

<style>
.ptz-drawer { background: #1e293b !important; color: #e2e8f0; }
.ptz-drawer .el-drawer__header { color: #e2e8f0; margin-bottom: 10px; }
.ptz-drawer .el-drawer__body { background: #1e293b; overflow: auto; }
</style>